import theme from '~/shared/styles/theme'

export const checkOverLargeBoothType = (boothTypeInput: string) => {
  if (
    boothTypeInput === 'B0200004' ||
    boothTypeInput === 'B0200005' ||
    boothTypeInput === 'B0200006' ||
    boothTypeInput === 'B0200007'
  ) {
    return true
  }

  return false
}

export function getBoothStatusText(status: string): string {
  switch (status) {
    case 'B0100001':
      return '신청서 접수 완료'
    case 'B0100002':
      return '수정 요청'
    case 'B0100003':
      return '결제 대기 중'
    case 'B0100004':
      return '참가 확정'
    case 'B0100005':
      return '환불 완료'
    case 'B0100006':
      return '취소 완료'
    case 'B0100008':
      return '환불 요청'
    case 'B0100009':
      return '입금 기한 초과'
    default:
      return '-'
  }
}

export function getBoothStatusColor(status: string): string {
  switch (status) {
    case 'B0100001':
      return `${theme.colors.grey_4}`
    case 'B0100002':
      return `${theme.colors.warning}`
    case 'B0100003':
      return `${theme.colors.pink_3}`
    case 'B0100004':
      return `${theme.colors.mint_3}`
    case 'B0100005':
      return `${theme.colors.pink_3}`
    case 'B0100006':
      return `${theme.colors.mint_3}`
    case 'B0100008':
      return `${theme.colors.pink_3}`
    case 'B0100009':
      return `${theme.colors.grey_4}`
    default:
      return `${theme.colors.grey_4}`
  }
}
